import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Domain } from "../../schema/types/domain/entity";

export const domainApi = createApi({
  reducerPath: "domainApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Domain"],
  endpoints: (builder) => ({
    getDomain: builder.query<Domain, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Domain", id: link }],
    }),
    getDomains: builder.query<Domain, string>({
      queryFn: async (orgName) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: `/org/${orgName}/domain` });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, orgName) => [{ type: "Domain", id: `/org/${orgName}/domain` }],
    }),
  }),
});

export const { useGetDomainQuery, useGetDomainsQuery } = domainApi;
